<template>
  <div class="diamond">
    <img
      class="bg"
      v-if="imgList[getTheme].status == true"
      src="@/img/mebg_diamond.png"
      alt
    />
    <div class="diamond_bg" v-else></div>
    <div class="diamond_box">
      <div class="diamond_nav">
        <div class="diamond_nav_url" @click="ret">
          <img class="diamond_nav_img" src="@/img/tag_tab_return_1.png" alt />
        </div>
        <div class="diamond_nav_text">{{ $t("Pay.Current_Diamonds") }}</div>
      </div>
      <div class="my_diamond_box">
        <img class="my_Diamonds_img" src="@/img/Diamonds.png" alt="" />
        {{ pspre(balance) }}
      </div>
      <div @touchstart="btntouchstart()" @touchend="btntouchend()">
        <router-link
          class="Diamonds_btn"
          :class="btnstate ? 'Diamonds_btn_active' : ''"
          tag="div"
          to="/billingDetails"
        >
          {{ $t("Pay.Billing_Breakdowns") }}
        </router-link>
      </div>
      <!--  -->
      <div class="diamond_centent" v-if="rechargeItems.length <= 0">
        <loading></loading>
      </div>
      <!--  -->
      <div class="diamond_centent" v-if="rechargeItems.length > 0">
        <!-- @touchmove='Playtouchmove($event,index)' -->
        <div
          class="diamond_list"
          :class="bg_index == index ? 'diamond_list_active' : ''"
          v-for="(item, index) in rechargeItems"
          @click="paymoney(index)"
          @touchstart="Playtouchstart($event, index)"
          @touchend="Playtouchend($event, index)"
          :key="index"
        >
          <div class="diamond_list_show">
            <div class="diamond_list_left">
              <div class="diamond_list_gold">
                <img
                  class="diamond_list_gold_img"
                  src="@/img/Diamonds.png"
                  alt
                />
              </div>
              <div class="diamond_list_diamond">
                <div class="diamond_list_diamond_title">
                  {{ pspre(item.cnt) }}
                </div>
              </div>
            </div>
            <!-- stop -->
            <div>
              <div class="diamond_botton">
                {{ item.price.unit }}{{ item.price.cnt / item.price.ratio }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 这个是购买的下拉 -->
    <pay
      v-on:payBtns="payBtns"
      v-on:payhike="payhike"
      v-on:paystatus="paystatus"
      :commodityId="currentPurchaseItem.id"
      :payBtn="payBtn"
      :ispay="ispay"
      :price="currentPurchaseItem.price ? currentPurchaseItem.price : {}"
      :name="currentPurchaseItem.name"
      :rechargeItemId="orderId"
    >
      <div style="text-align: center;margin-top: 0.65rem;">
        <div class="payMoney">
          {{ currentPurchaseItem.price ? currentPurchaseItem.price.unit : ""
          }}{{
            currentPurchaseItem.price
              ? currentPurchaseItem.price.cnt / currentPurchaseItem.price.ratio
              : ""
          }}
        </div>
        <div class="payText">
          {{ currentPurchaseItem.name }}
        </div>
      </div>
    </pay>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import configs from "@/config/config.js";
import loading from "@/components/config/loading.vue";
// 引入付款下拉框
import pay from "@/components/pay";
export default {
  components: {
    pay,
    loading
  },
  data() {
    return {
      loadmore: false,
      ispay: false,
      rechargeItems: [],
      currentPurchaseItem: {},
      balance: 0,
      // 付款的状态
      payBtn: false,
      orderId: "",
      paystatusIs: "",
      commodityId: "",

      bg_index: -1,
      btnstate: false,
      count: 0,
      payId: "",
      status: "",
      outTradeCode: "",
      payCheckIndex: 0,
      getTheme: "",
      imgList: {
        khalaspay: {
          status: false
        },
        dark: {
          status: false
        },
        lavender: {
          status: false
        },
        orange: {
          status: false
        },
        "night-blue": {
          status: false
        },
        regular: {
          status: true
        }
      }
    };
  },
  watch: {
    $route(to, from) {}
  },

  created() {
    this.getTheme = configs.getTheme();
  },
  methods: {
    ...mapActions("user", ["tipMessage"]),
    ...mapActions("pay", [
      "GetWareList",
      "Coin",
      "OrderCreate",
      "PayCreate",
      "OrderState",
      "OrderClose",
      "khalasPayCheck"
    ]),
    // 充值返回回来是否成功
    async getKhalasPayCheck() {
      const self = this;
      const res = await this.khalasPayCheck({
        $axios: this.$axios,
        appId: configs.bipAppId(),
        thirdPayId: this.payId,
        payId: this.outTradeCode
      });
      if (res.stateCode > 0) {
        if (res.stateCode == 1) {
          self.getCoin();
        } else if (res.stateCode == 2) {
          self.payCheckIndex = self.payCheckIndex + 1;
          if (self.payCheckIndex <= 5) {
            setTimeout(() => {
              self.getKhalasPayCheck();
            }, 2000);
          } else {
            self.tipMessage({ context: self.$t("Pay.abnormity") });
            self.payCheckIndex = 0;
          }
        }
      }
    },

    getCoin() {
      const self = this;
      self
        .Coin({
          $axios: self.$axios,
          appId: configs.bipAppId()
        })
        .then(res => {
          if (res && res.stateCode == 1) {
            self.balance = res.resultInfo.data;
          }
        });
    },

    getPayAppid() {
      // 获取是否需要内购
      if (window.TgaBridge) {
        TgaBridge.getPayAppid().then(res => {
          if (res && res.actived) {
            localStorage.setItem("actived", res.actived);
          }
          if (res && res.enabled) {
            localStorage.setItem("enabled", res.enabled);
          }
        });
      }
    },
    // 查看账单的状态
    btntouchstart() {
      this.btnstate = true;
    },
    btntouchend() {
      this.btnstate = false;
    },

    //
    Playtouchstart(e, index) {
      this.bg_index = index;
      // this.bg_scrollTop = document.querySelector('.diamond').scrollTop;
    },
    Playtouchend(e, index) {
      this.bg_index = -1;
    },

    // Playtouchmove(e, index) {
    //   var top = document.querySelector('.diamond').scrollTop;
    //   if (this.bg_scrollTop - top > 8 || top - this.bg_scrollTop > 8) {
    //     this.bg_index = -1;
    //   }
    // },

    payBtns(data) {
      this.payBtn = data;
    },
    // 轮询订单状态
    async setOrderState() {
      var self = this;
      if (!this.userInfo.txnId) {
        return;
      }
      if (self.count > 6) {
        this.$router.push({
          path: "/pay_details",
          query: {
            type: "-99"
          }
        });
        self.ispay = false;
        return;
      }
      self.count = self.count++;
      const res = await this.OrderState({
        $axios: this.$axios,
        appId: configs.bipAppId(),
        orderId: this.orderId
      });

      if (res.stateCode == 1) {
        if (res.resultInfo.data == 0) {
          setTimeout(() => {
            self.setOrderState();
          }, 2000);
        } else if (res.resultInfo.data <= 1) {
          // 关闭支付下拉页面
          self.ispay = false;

          // 跳转到页面
          this.$router.push({
            path: "/pay_details",
            query: {
              type: res.resultInfo.data
            }
          });
        } else if (this.paystatusIs == 1 && res.resultInfo.data < 0) {
          // 关闭支付下拉页面
          self.ispay = false;
          // 跳转到页面
          this.$router.push({
            path: "/pay_details",
            query: {
              type: "-99"
            }
          });
        } else {
          // 关闭支付下拉页面
          self.ispay = false;

          // 跳转到页面
          this.$router.push({
            path: "/pay_details",
            query: {
              type: "-1"
            }
          });
        }
      }
    },

    // 分享出现下拉框
    async paymoney(idx) {
      var self = this;
      this.currentPurchaseItem = this.rechargeItems[idx];
      // 判断  创建订单 如果是内购的
      // !configs.getStorage("actived")
      if (true) {
        if (!this.userInfo.txnId) {
          return;
        }
        self.ispay = true;
        const res = await this.OrderCreate({
          $axios: this.$axios,
          appId: configs.bipAppId(),
          wareId: this.currentPurchaseItem.id
        });
        if (res.stateCode == 1) {
          this.orderId = res.resultInfo.data;
        }
      } else {
        this.payBtn = false;
        // 这里是是创建订单且 支付单
        const res = await this.OrderCreate({
          $axios: this.$axios,
          appId: configs.bipAppId(),
          wareId: this.currentPurchaseItem.id
        });
        if (res.stateCode == 1) {
          this.orderId = res.resultInfo.data;
          // 支付单
          const pay = await this.PayCreate({
            $axios: this.$axios,
            appId: configs.bipAppId(),
            orderId: this.orderId,
            payType: 1
          });
          if (pay.stateCode == 1) {
            if (TgaBridge) {
              var Create = pay.resultInfo.data;
              TgaBridge.appPay(
                JSON.stringify({
                  id: this.currentPurchaseItem.id,
                  order: Create
                })
              ).then(res => {
                self.paystatus(res.change);
              });
            }
          }
        }
      }
    },
    // 触发支付是否成功  -1失败  -2 商品不存在  -3  1成功
    paystatus(data) {
      var self = this;
      if (data == 1) {
        this.paystatusIs = true;
        this.setOrderState();
      } else if (data == -1) {
        this.paystatusIs = false;
        this.payBtn = false;
      } else if (data == -2) {
        this.tipMessage({ context: self.$t("Pay.no_goods") });
        this.payBtn = false;
      } else if (data == -3) {
        this.tipMessage({ context: self.$t("Pay.Network") });
        this.payBtn = false;
      } else if (data == -4) {
        this.tipMessage({ context: self.$t("Pay.no_google") });
        this.payBtn = false;
      } else {
        this.paystatusIs = false;
        this.payBtn = false;
      }
    },

    // 关闭下拉
    async payhike(data) {
      this.ispay = data;
      const res = await this.OrderClose({
        $axios: this.$axios,
        appId: configs.bipAppId(),
        orderId: this.orderId
      });
    },
    // 后退
    ret() {
      if (this.status) {
        const urls = tgaPlatformSDK.util.url.getUrlQuery();
        this.$router.replace({
          path: "/index",
          query: {
            navigationbar: urls.navigationbar,
            msisdn: urls.msisdn,
            appId: urls.appId,
            txnId: urls.txnId
          }
        });
      } else {
        this.$router.go(-1);
      }
      // if(TgaBridge){
      //    TgaBridge.finishPage('close')
      // }else{
      //   if(this.status == 'success'){
      //    this.$router.push({
      //      path: "/index"
      //    });
      //   }else{
      //     this.$router.go(-1);
      //   }
      // }
    },

    pspre(data) {
      var value = data + "";
      var val = "";
      if (value) {
        var rt = [],
          num,
          tail;
        if (value.indexOf(".") > 0) {
          num = value.slice(0, value.indexOf("."));
          tail = value.slice(value.indexOf("."));
        } else {
          num = value.replace(/[^\d^\.]+/g, "");
          tail = "";
        }
        if (num.length > 3) {
          var mod = num.length % 3;
          val = mod == 0 ? "" : num.substring(0, mod);
          for (var i = 0; i < Math.floor(num.length / 3); i++) {
            if (mod == 0 && i == 0) {
              val += num.substring(mod + 3 * i, mod + 3 * i + 3);
            } else {
              val += "," + num.substring(mod + 3 * i, mod + 3 * i + 3);
            }
          }
          val += tail;
        } else {
          val = value;
        }
        return val;
      }
    }
  },
  mounted() {
    var self = this;
    document.addEventListener("visibilitychange", e => {
      if (document.hidden) {
        // 页面被挂起
      } else {
        self
          .Coin({
            $axios: self.$axios,
            appId: configs.bipAppId()
          })
          .then(res => {
            if (res && res.stateCode == 1) {
              self.balance = res.resultInfo.data;
            }
          });

        // 页面呼出
      }
    });
    //查询余额
    this.Coin({
      $axios: this.$axios,
      appId: configs.bipAppId()
    }).then(res => {
      if (res && res.stateCode == 1) {
        this.balance = res.resultInfo.data;
      }
    });

    this.GetWareList({
      $axios: this.$axios,
      appId: configs.bipAppId()
    }).then(res => {
      if (res && res.stateCode == 1) {
        this.rechargeItems = res.resultInfo.data;
      }
    });

    this.getPayAppid();
    this.payId = configs.GetQueryString("payId") || this.$route.query.payId;
    this.status = configs.GetQueryString("status") || this.$route.query.status;
    this.outTradeCode =
      configs.GetQueryString("outTradeCode") || this.$route.query.outTradeCode;
    // 判断下次进来KhalasPay 地址上的ID是不是存在 如果在就轮询
    if (this.payId && this.status == "success") {
      this.getKhalasPayCheck();
    }
  },
  computed: {
    ...mapState("user", ["userInfo"])
  }
};
</script>

<style scoped="scoped">
div,
img,
span {
  -moz-user-select: none; /* Firefox私有属性 */
  -webkit-user-select: none; /* WebKit内核私有属性 */
  -ms-user-select: none; /* IE私有属性(IE10及以后) */
  -khtml-user-select: none; /* KHTML内核私有属性 */
  -o-user-select: none; /* Opera私有属性 */
  user-select: none; /* CSS3属性 */
}
.diamond {
  width: 100%;
  height: 100%;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
}
.diamond_bg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  background-color: var(--diamondBg);
}
.diamond_box {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.diamond_nav {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 1.44rem;
  position: relative;
}

.diamond_nav_url {
  box-sizing: border-box;
  width: 1.2rem;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  padding-left: 0.54rem;
  display: flex;
  align-items: center;
}
.diamond_nav_img {
  width: 0.72rem;
  height: 0.72rem;
}

.diamond_nav_text {
  font-size: 0.54rem;
  color: #ffffff;
}

.my_diamond_box {
  margin: 0.58rem 0 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 1rem;
  color: #ffffff;
  font-size: 0.9rem;
}
.my_Diamonds_img {
  width: 0.66rem;
  height: 0.66rem;
  margin-right: 0.3rem;
}

.Diamonds_btn {
  width: 3.7rem;
  height: 0.84rem;
  background-color: var(--diamondListBackgroundBtn);
  box-shadow: inset 0px -0.1rem 0px 0px rgba(0, 0, 0, 0.05);
  border: solid 0.02rem rgba(0, 0, 0, 0.15);
  color: var(--diamondListColorBtn);
  font-size: 0.36rem;
  padding-bottom: 0.05rem;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.45rem auto 0;
  border-radius: 0.6rem;
}
.Diamonds_btn_active {
  background-color: var(--diamondListBackgroundBtnActive);
}

.diamond_centent {
  position: absolute;
  top: 5.34rem;
  left: 0;
  bottom: 0;
  width: 100%;
  height: auto;
  overflow: auto;
  background-color: var(--diamondListBg);
  border-radius: 0.48rem 0.48rem 0 0;
  padding: 0.44rem 0 0 0;
}
.diamond_list {
  padding: 0 0.49rem 0 0.39rem;
}

.diamond_list_active {
  background-color: var(--diamondListBackgroundActive);
}
.diamond_centent .diamond_list_show {
  border-top: var(--diamondListBorber);
  height: 1.62rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.diamond_centent .diamond_list:nth-of-type(1) .diamond_list_show {
  border-top: none;
}
.diamond_list_left {
  display: flex;
}
.diamond_list_gold {
  margin-right: 0.44rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.diamond_list_gold_img {
  width: 0.84rem;
  height: 0.84rem;
}
.diamond_list_diamond {
  display: flex;
  align-items: center;
}
.diamond_list_diamond_title {
  font-size: 0.48rem;
  color: var(--diamondListColor);
}

.diamond_botton {
  /* width: 1.34rem; */
  min-width: 1.34rem;
  padding: 0 0.15rem;
  height: 0.72rem;
  background-color: var(--diamondListBtn);
  box-shadow: inset 0px -0.06rem 0px 0px rgba(0, 0, 0, 0.05);
  border-radius: 0.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 0.36rem;
}
</style>



// WEBPACK FOOTER //
// src/components/diamond.vue